import { Condition } from '@api/api/compass-schema';
import { SnakeMeta } from '@api/api/timeseries-schema';
import { formatTicker } from '@api/mappers/formatTicker';
import { postEntity } from '@terminal/services/entities/entity-service';
import { fetchSnakeMeta } from '@terminal/services/overview-widget/overview-widget-service';

import { validateCondition } from '../validate-condition/validateCondition';

export interface MappedConditions extends Condition {
  id: string;
  active: boolean;
  confirmed: boolean;
  isValid: boolean;
  pendingRun: boolean;
  entityName: string;
  formattedTicker: string;
  snakeName: string;
  askedQuestion?: string;
  label?: string;
}

const getSnakeName = (data: SnakeMeta, fallback: string) => {
  try {
    return data.name.english;
  } catch {
    return fallback;
  }
};

type EnrichedConditionsProps = {
  condition: Condition;
  askedQuestion?: string;
  isDefaultConfirmed?: boolean;
};

export const enrichedConditions = async ({
  condition,
  askedQuestion,
  isDefaultConfirmed,
}: EnrichedConditionsProps): Promise<MappedConditions> => {
  const entity = await postEntity(condition.entity);

  let snakeMeta: SnakeMeta | undefined;

  try {
    snakeMeta = await fetchSnakeMeta(condition.snake);
  } catch (e) {
    snakeMeta = undefined;
  }

  return {
    ...condition,
    entityName: entity.data?.name ?? condition.entity,
    formattedTicker: entity.data ? formatTicker(entity.data) : condition.entity,
    snakeName: !snakeMeta
      ? condition.snake
      : getSnakeName(snakeMeta, condition.snake),
    id: crypto.randomUUID(),
    active: true,
    confirmed: !!isDefaultConfirmed,
    isValid: validateCondition(condition),
    pendingRun: true,
    askedQuestion,
  };
};
